import React from 'react';
import Buttons from 'components/Buttons';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import CoachingAvatar from 'assets/images/coaching/coaching_avatar.svg';
import CoachingGetHelpButton from 'coaching/components/CoachingGetHelpButton';

import './styles/CoachingViewHeader.scss';

type Props = {
  title: string;
  helpButtonEventKey?: string;
  isCoach?: boolean;
};

export default function CoachingViewHeader({ title, helpButtonEventKey, isCoach }: Props) {
  return (
    <div className="CoachingViewHeader">
      <MediaObject figure="right" className="CoachingViewHeader-top">
        <div className="CoachingViewHeader-left">
          <div className="CoachingViewHeader-left-group">
            <MediaObject center gutter="small">
              <Image width={40} src={CoachingAvatar} />
              <div>
                <Text size="large" element="div" truncate weight="semibold">
                  {title}
                </Text>
              </div>
            </MediaObject>
          </div>
        </div>
        <div className="CoachingViewHeader-right">
          <Buttons>
            <CoachingGetHelpButton eventKey={helpButtonEventKey} isCoach={isCoach} />
          </Buttons>
        </div>
      </MediaObject>
    </div>
  );
}
